import { render } from "./component_import_template_modal.vue?vue&type=template&id=10b13333"
import script from "./component_import_template_modal.vue?vue&type=script&lang=js"
export * from "./component_import_template_modal.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployer/asset-portal/releases/20260828153143/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__